import { HTTPMethod } from "../utils/helper";
import { apiCall } from "../utils/serviceCall";

export class CuratorCompanyControllerApi {
  static async patch(id: string, params?: any) {
    return apiCall(HTTPMethod.PATCH, `/curator_companies/${id}`, params);
  }
}
